import React from 'react';
import { Github, Linkedin, Mail, MapPin, Phone } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'GitHub',
      icon: <Github size={20} />,
      url: 'https://github.com/SamirTalkal'
    },
    {
      name: 'LinkedIn',
      icon: <Linkedin size={20} />,
      url: 'https://www.linkedin.com/in/samir-ahmed-talkal/'
    },
    {
      name: 'Email',
      icon: <Mail size={20} />,
      url: 'mailto:samirtalkal@gmail.com'
    }
  ];

  return (
    <footer className="bg-gray-900 dark:bg-dark-900 text-white">
      <div className="container-max">
        <div className="py-12">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Brand */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold gradient-text">
                Samir Ahmed Talkal
              </h3>
              <p className="text-gray-400 max-w-md">
                AI Engineer based in Bengaluru, India, specializing in enterprise-grade AI agents, LLMs,
                and RAG pipelines. Passionate about building production-ready conversational AI systems
                that drive real business value.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#home" className="text-gray-400 hover:text-white transition-colors">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#about" className="text-gray-400 hover:text-white transition-colors">
                    About
                  </a>
                </li>
                <li>
                  <a href="#experience" className="text-gray-400 hover:text-white transition-colors">
                    Experience
                  </a>
                </li>
                <li>
                  <a href="#projects" className="text-gray-400 hover:text-white transition-colors">
                    Projects
                  </a>
                </li>
                <li>
                  <a href="#skills" className="text-gray-400 hover:text-white transition-colors">
                    Skills
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Get In Touch</h4>
              <div className="space-y-3 text-gray-400">
                <div className="flex items-center space-x-2">
                  <Mail size={16} className="text-primary-400" />
                  <a href="mailto:samirtalkal@gmail.com" className="hover:text-white transition-colors">
                    samirtalkal@gmail.com
                  </a>
                </div>
                <div className="flex items-center space-x-2">
                  <Phone size={16} className="text-primary-400" />
                  <a href="tel:+918805085163" className="hover:text-white transition-colors">
                    +91-8805085163
                  </a>
                </div>
                <div className="flex items-center space-x-2">
                  <MapPin size={16} className="text-primary-400" />
                  <span>Bengaluru, India</span>
                </div>
              </div>
              
              {/* Resume Download */}
              <div className="mt-6">
                <a
                  href="/SamirTalkal_Resume.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg text-sm font-medium transition-colors"
                >
                  Download Resume
                </a>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="border-t border-gray-800 dark:border-dark-700 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © {currentYear} Samir Ahmed Talkal. All rights reserved.
              </p>
              <div className="flex space-x-4 mt-4 md:mt-0">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-gray-800 dark:bg-dark-700 hover:bg-primary-600 dark:hover:bg-primary-500 rounded-lg flex items-center justify-center text-gray-400 hover:text-white transition-colors"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 